import type { SupportedOnboardingTourStep } from 'models';
import { useMemo } from 'react';

export const useSupportedStepProgress = ({
  step,
  steps,
}: {
  step: SupportedOnboardingTourStep;
  steps: SupportedOnboardingTourStep[];
}) =>
  useMemo(() => {
    const currentStepIndex = steps.findIndex((supportedStep) => supportedStep.step === step.step);

    const current = Math.max(currentStepIndex, 0) + 1;
    const total = Math.max(steps.length, 1);

    return {
      current,
      total,
    };
  }, [step.step, steps]);
